import { render, staticRenderFns } from "./AdditionalInformationSection.vue?vue&type=template&id=50835944&scoped=true"
import script from "./AdditionalInformationSection.vue?vue&type=script&lang=js"
export * from "./AdditionalInformationSection.vue?vue&type=script&lang=js"
import style0 from "./AdditionalInformationSection.vue?vue&type=style&index=0&id=50835944&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50835944",
  null
  
)

export default component.exports